import React from 'react';

import { Box, Typography } from '@mui/material';

import { enqueueSnackbar } from '@common/components/SnackBar';

import * as Styled from '../ContentCard/styled';

interface CopyCardProps {
	title: string;
	text: string;
	withCopy?: boolean;
}

function CopyCard({ title, text, withCopy }: CopyCardProps) {
	const handleCopy = async () => {
		if (!withCopy) return;

		await navigator.clipboard.writeText(`
		  ${title}
		  ${text}
		`);

		enqueueSnackbar('Copied successfully!', {
			variant: 'success',
		});
	};

	return (
		<Styled.StyledCard minHeight="108px">
			<Box display="flex" justifyContent="space-between">
				<Typography variant="subtitle2" fontWeight={600}>
					{title}
				</Typography>
				{withCopy && <Styled.CopyIcon onClick={handleCopy} />}
			</Box>

			<Typography variant="subtitle2" fontWeight={300}>
				{text}
			</Typography>
		</Styled.StyledCard>
	);
}

export default CopyCard;
